module.exports = __webpack_public_path__ + "img/facility-50.9cb511f4.svg";